import { IReadOptions } from "@samc/common";
import { GetSpaceReportItems, IDomainReportTreeItem, IDomainReportFolderItem } from '@samc/querybuilder';
import { CachedDataSource } from './BaseDataSources';


export class LSReportSource extends CachedDataSource<any> {
  protected async loadData(options: IReadOptions, abortController?: AbortController | undefined): Promise<IDomainReportFolderItem[]> {
    var response = await GetSpaceReportItems('Report');
    if (response === undefined)
      return [];

    return this.parseFolderList(response.treeResult);
  }

  private parseFolderList(item: IDomainReportTreeItem): IDomainReportFolderItem[] {
    // .NET serializer GUID type is lowercased, so ensure Folder Item GUID string is lowercased for comparisons
    item.items.forEach(x => x.guid = x.guid.toLowerCase());

    let list = item.items;
    for (let i = 0; i < item.subfolders.length; ++i) {
      list = list.concat(this.parseFolderList(item.subfolders[i]));
    }
    return list;
  }
}